import { combineReducers } from 'redux';
import accounts from './accounts';
import tags from './categories';
import transactions from './transactions';

export default combineReducers({ accounts, tags, transactions });
